import PropTypes from 'prop-types';

const CheckboxInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  disabled,
  hasOtherOption,
  choices,
}) => {
  const addChoice = (choice) => {
    const newValues = values[id]
      ? [...values[id], { type: 'default', value: choice }]
      : [{ type: 'default', value: choice }];

    setValue({
      [id]: newValues,
    });
  };
  const removeChoice = (choice) => {
    const newValues = values[id].filter(({ value }) => value !== choice);

    setValue({
      [id]: newValues,
    });
  };
  const onChangeOther = (value) => {
    if (value) {
      const newValues = values[id]
        ? [
            ...values[id]?.filter(({ type }) => type !== 'other'),
            { type: 'other', value },
          ]
        : [{ type: 'other', value }];
      setValue({
        [id]: newValues,
      });
    } else {
      const newValues = values[id]
        ? [...values[id]?.filter(({ type }) => type !== 'other')]
        : undefined;
      setValue({
        [id]: newValues,
      });
    }
  };
  const handleOtherValue = (other) =>
    other?.find((i) => i.type === 'other')?.value;
  return (
    <div className="input-wrapper">
      <label htmlFor={id}>
        {title} {isRequired && <span className="color-red">*</span>}
      </label>
      {choices.map((choice) => {
        const isValuesArray = Array.isArray(values[id]);
        const checked =
          isValuesArray && values[id]?.find(({ value }) => value === choice);
        const onChange = () => {
          if (checked) {
            removeChoice(choice);
          } else {
            addChoice(choice);
          }
        };
        return (
          <div className="checkbox-input-wrapper" key={`${id}${choice}`}>
            <input
              type="checkbox"
              id={`${id}${choice}`}
              label={choice}
              onChange={onChange}
              disabled={disabled}
              value={checked}
              defaultChecked={checked}
            />
            <label htmlFor={`${id}${choice}`}>{choice}</label>
          </div>
        );
      })}
      {hasOtherOption && (
        <div className="other-input-wrapper">
          <label htmlFor={id}>Other:</label>
          <input
            id={id}
            className="form-control"
            type="text"
            autoComplete="off"
            disabled={disabled}
            value={handleOtherValue(values[id])}
            onChange={(e) => {
              onChangeOther(e.target.value);
            }}
          />
        </div>
      )}
    </div>
  );
};

CheckboxInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  choices: PropTypes.array,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  hasOtherOption: PropTypes.bool,
  disabled: PropTypes.bool,
  values: PropTypes.shape(),
};

export default CheckboxInput;
